module.exports = __webpack_public_path__ + "static/media/search.0078aa9f.png";